module.exports = {"654325100":"青河镇","654325101":"塔克什肯镇","654325102":"阿热勒托别镇","654325103":"阿格达拉镇","654325104":"阿热勒镇","654325202":"萨尔托海乡","654325203":"查干郭勒乡","654325204":"阿尕什敖包乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654325.json
// module id = 3148
// module chunks = 0